import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import ReturnClass from "../pages/Signup/ReturnClass";
import { useNavigate } from "react-router-dom"
import axios from "axios"
import ExamInfo from "./ExamInfo";
import SubjectInfo from "./SubjectInfo";
import ModuleInfo from "./ModuleInfo";
import SubModuleInfo from "./SubModuleInfo";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import JoditEditor from "jodit-react";
import "./MasterSettings.css";
import { ToastContainer, toast } from 'react-toastify';

function MasterSetting() {

    const apiurl = window.SERVICE_URL;

    const editor = useRef(null)
    const [content, setContent] = useState('')


    const [Exam, setExam] = useState(false);
    const ExamClose = () => setExam(false);
    const handleExam = () => setExam(true);

    const [Subject, setSubject] = useState(false);
    const subjectClose = () => setSubject(false);
    const handleSubject = () => setSubject(true);

    const [SubModule, setSubModule] = useState(false);
    const SubModuleClose = () => setSubModule(false);
    const handleSubModule = () => setSubModule(true);

    const [AddModule, setAddModule] = useState(false);
    const AddModuleClose = () => setAddModule(false);
    const handleAddModule = () => setAddModule(true);

    const [EditExam, setEditExam] = useState(false);
    const EditExamClose = () => setEditExam(false);
    const handleEditExam = () => setEditExam(true);

    const [EditSubject, setEditSubject] = useState(false);
    const EditsubjectClose = () => setEditSubject(false);
    const handleEditSubject = () => setEditSubject(true);

    const [EditSubModule, setEditSubModule] = useState(false);
    const EditSubModuleClose = () => setEditSubModule(false);
    const handleEditSubModule = () => setEditSubModule(true);

    const [EditModule, setEditModule] = useState(false);
    const EditModuleClose = () => setEditModule(false);
    const handleEditModule = () => setEditModule(true);

    const [MainDiv, setMainDiv] = useState({ display: 'block' });
    const [SubDiv, setSubDiv] = useState({ display: 'none' });

    if (localStorage.getItem("loginsession") != null) {
        const res = JSON.parse(localStorage.getItem("loginsession"));
        ReturnClass.EmailID = res.EmailID;
        ReturnClass.MobileNumber = res.MobileNumber;
        ReturnClass.AccessToken = res.AccessToken;
        ReturnClass.UserID = res.UserID;
        ReturnClass.PartnerID = res.PartnerID;
    }

    const [data, dataSet] = useState([]);

    useEffect(() => {
        GetAllExams();
    }, [dataSet]);

    const [DataById, DataByIdSet] = useState([]);
    useEffect(() => {
    }, [DataByIdSet]);


    function validateForm(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter New Subject";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            AddNewSubject();
            status = true;
        }
        return status;
    }
    function validateFormUpdate(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter New Subject";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            UpdateNewSubject();
            status = true;
        }
        return status;
    }

    function validateFormAddModule(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Module";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            AddNewModule();
            status = true;
        }
        return status;
    }
    function validateFormUpdateModule(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Module";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            UpdateModule();
            status = true;
        }
        return status;
    }

    //Add Exams
    const AddExams = async (e) => {
        e.preventDefault();
        var ExamsName = document.getElementById("Name").value;
        var description = document.getElementById("Description").value;

        const AddExamsForm = {
            ExamId: 0,
            ExamName: ExamsName,
            Description: description,
            Active: false,
            UserId: ReturnClass.PartnerID,
            QuestionCount: 0,
            PartnerID: ReturnClass.UserID
        };

        await axios
            .post(apiurl+`api/AddExam`, AddExamsForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
              
                toast.success(result.data.outMessage);
                GetAllExams();
                ExamClose();

            })
            .catch(error => {
                console.log(error.response)
            });

    };
    //Add New Subject
    const AddNewSubject = async () => {
       
        var subjectName = document.getElementById("Name").value;
        var subjectdescription = document.getElementById("Description").value;

      
        const AddNewSubjectForm = {
            SubjectId: 0,
            Name: subjectName,
            Description: subjectdescription,
            Examid: ExamInfo.ExamId,
            Active: true,
            UserId: ReturnClass.UserID,
            CreatedDate: new Date(),
            QuestionCount: 0,
            PartnerId: 0,
            encPartnerID: ReturnClass.PartnerID
        };

        await axios
            .post(apiurl + `api/AddSubjects`, AddNewSubjectForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllSubject(ExamInfo.ExamId);
                subjectClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };

    //Add Module
    const AddNewModule = async () => {
      

        var moduleName = document.getElementById("ModuleName").value;
        var moduledescription = document.getElementById("ModuleDescription").value;

        
        const AddModuleForm = {
            ModuleId: 0,
            Name: moduleName,
            Description: moduledescription,
            //Subjectid: ModuleInfo.Subjectid,
            Subjectid: SubjectInfo.SubjectId,
            Active: true,
            UserId: ReturnClass.UserID,
            CreatedDate: new Date(),
            QuestionCount: 0,
            PartnerId: 0,
            encPartnerID: ReturnClass.PartnerID
        };

        await axios
            .post(apiurl + `api/AddModules`, AddModuleForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllModules(SubjectInfo.SubjectId);
                AddModuleClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };
    //Add Sub Module
    const AddNewSubModule = async (e) => {
        e.preventDefault();
        var submoduleName = document.getElementById("SubModuleName").value;
        var submoduledescription = document.getElementById("SubModuleDescription").value;


        const AddSubModuleForm = {
            SubModuleId: 0,
            Name: submoduleName,
            Description: submoduledescription,
            //ModuleId: SubModuleInfo.ModuleId,
            ModuleId: ModuleInfo.ModuleId,
            Active: true,
            UserId: ReturnClass.UserID,
            CreatedDate: new Date(),
            QuestionCount: 0,
            PartnerId: 0,
            encPartnerID: ReturnClass.PartnerID
        };


        await axios
            .post(apiurl + `api/AddSubModules`, AddSubModuleForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllSubModules(ModuleInfo.ModuleId);
                SubModuleClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };

    //Get by Exams Id
    async function GetExamDetailsByExamID(id) {
        DataByIdSet([]);
       
        await axios.get(apiurl +`api/GetExamInfoByExamID?PartnerID=${ReturnClass.PartnerID}&ExamId=${id}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
              
                DataByIdSet(response.data);
                ExamInfo.ExamName = response.data.examName;
                ExamInfo.Description = response.data.description;
                ExamInfo.ExamId = response.data.examId;
                setMainDiv({ display: 'none' });
                setSubDiv({ display: 'block' });
                GetAllSubject(id)
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const UpdateExams = async (e) => {
        e.preventDefault();
        var ExamsName = document.getElementById("Name").value;
        var description = document.getElementById("Description").value;
        var ID = document.getElementById("ExamId").value;
       
        const UpdateExamsForm = {
            ExamId: ID,
            ExamName: ExamsName,
            Description: description,
            Active: false,
            UserId: ReturnClass.PartnerID,
            QuestionCount: 0,
            PartnerID: ReturnClass.UserID
        };

        await axios
            .post(apiurl + `api/AddExam`, UpdateExamsForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                    
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllExams();
                EditExamClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };
    //Get by ID New Subject

    const [NewSubjectId, NewSubjectIdSet] = useState([]);
    useEffect(() => {
    }, [NewSubjectIdSet]);

    async function GetNewSubjectByID(ExamID, SubjectIDs,subjectName) {
        NewSubjectIdSet([]);

        await axios.get(apiurl +`api/GetSubjectBySubjectId?PartnerID=${encPartnerID}&Examid=${ExamID}&SubjectId=${SubjectIDs}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
                NewSubjectIdSet(response.data);
                SubjectInfo.SubjectId = SubjectIDs;
                SubjectInfo.Name = subjectName;
            })
            .catch(error => {
                console.log(error.response)
            });

    }

    const UpdateNewSubject = async () => {
       // e.preventDefault();
        var subname = document.getElementById("subName").value;
        var subdescription = document.getElementById("subDescription").value;
        var EID = document.getElementById("ExamID").value;
        var SubID = document.getElementById("SubjectID").value;

        const UpdateSubjectForm = {

            ExamID: EID,
            SubjectID: SubID,
            Name: subname,
            Description: subdescription,
            Active: true,
            QuestionCount: 0,
            UserId: ReturnClass.UserID,
            CreatedDate: new Date(),
            PartnerId: 0,
            encPartnerID: ReturnClass.PartnerID

        };

        await axios
            .post(apiurl + `api/AddSubjects`, UpdateSubjectForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllSubject(ExamInfo.ExamId);
                EditsubjectClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };
    //Get by ID Module

    const [NewModuleId, NewModuleIdSet] = useState([]);
    useEffect(() => {
    }, [NewModuleIdSet]);

    async function GetModuleByID(SubjectID, ModuleIDs, ModuleName) {

        NewModuleIdSet([]);
        await axios.get(apiurl +`api/GetModuleByModuleID?PartnerID=${encPartnerID}&SubjectId=${SubjectID}&ModuleId=${ModuleIDs}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
             
                NewModuleIdSet(response.data);
                SubjectInfo.SubjectId = SubjectID;
                ModuleInfo.ModuleId = ModuleIDs;
                ModuleInfo.Name = ModuleName;
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const UpdateModule = async () => {

        var SubID = document.getElementById("SubjectID").value;
        var ModID = document.getElementById("ModuleID").value;
        var moduleName = document.getElementById("ModuleName").value;
        var moduledescription = document.getElementById("ModuleDescription").value;


        const UpdateModuleForm = {
            Subjectid: SubID,
            ModuleId: ModID,
            Name: moduleName,
            Description: moduledescription,
            Active: true,
            UserId: ReturnClass.UserID,
            CreatedDate: new Date(),
            QuestionCount: 0,
            PartnerId: 0,
            encPartnerID: ReturnClass.PartnerID
        };

        await axios
            .post(apiurl + `api/AddModules`, UpdateModuleForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllModules(SubjectInfo.SubjectId);
                EditModuleClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };

    //Get by ID sub Module

    const [NewsubModuleId, NewSubModuleIdSet] = useState([]);
    useEffect(() => {
    }, [NewSubModuleIdSet]);

    async function GetSubModuleByID(ModuleID, SubModuleID) {
        NewSubModuleIdSet([]);
        await axios.get(apiurl +`api/GetSubModuleBySubModuleID?PartnerID=${encPartnerID}&ModuleId=${ModuleID}&SubModuleId=${SubModuleID}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
                NewSubModuleIdSet(response.data);
            })
            .catch(error => {
                console.log(error.response)
            });

    }

    const UpdateSubModule = async (e) => {
        e.preventDefault();

        var SubModID = document.getElementById("SubModuleID").value;
        var ModuleIDs = document.getElementById("ModuleID").value;
        var submoduleName = document.getElementById("SubModuleName").value;
        var submoduledescription = document.getElementById("SubModuleDescription").value;

        debugger;
        const UpdateSubModuleForm = {
            ModuleId: ModuleIDs,
            SubModuleId: SubModID,
            Name: submoduleName,
            Description: submoduledescription,
            Active: true,
            UserId: ReturnClass.UserID,
            CreatedDate: new Date(),
            QuestionCount: 0,
            PartnerId: 0,
            encPartnerID: ReturnClass.PartnerID
        };

        await axios
            .post(apiurl + `api/AddSubModules`, UpdateSubModuleForm,
                {
                    headers:
                    {
                        "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                        "Content-Type": "application/json"
                    },
                })

            .then(function (result) {
                toast.success(result.data.outMessage);
                GetAllSubModules(ModuleInfo.ModuleId);
                EditSubModuleClose();
            })
            .catch(error => {
                console.log(error.response)
            });

    };

    const encPartnerID = ReturnClass.PartnerID;
    const [SubjectList, SubjectIdSet] = useState([]);

    const [ModuleList, ModuleSet] = useState([]);
    const [SubModuleList, SubModuleSet] = useState([]);

    // Get Exams List
    async function GetAllExams() {
        await axios.get(apiurl + `api/GetAllExamList?PartnerId=` + ReturnClass.PartnerID,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {
                dataSet(response.data);
            })
            .catch(error => {
                console.log(error.response)
            });
    }
    // Get Subject List
    async function GetAllSubject(ExamID) {

        await axios.get(apiurl +`api/GetAllSubjectByExamID?PartnerID=${encPartnerID}&ExamId=${ExamID}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {

                SubjectIdSet(response.data);
                //SubjectInfo.Name = response.data[0].name;
            })
            .catch(error => {
                console.log(error.response)
            });
    }
    // Get Module List
    async function GetAllModules(SubjId) {

        await axios.get(apiurl +`api/GetAllModulesBySubjectId?PartnerID=${encPartnerID}&SubjectId=${SubjId}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {

                ModuleSet(response.data);
                //ModuleInfo.Name = response.data[0].name;
                //ModuleInfo.Subjectid = response.data[0].subjectid;
            })
            .catch(error => {
                console.log(error.response)
            });
    }
    //Get SubModule List
    async function GetAllSubModules(ModuleID) {

        await axios.get(apiurl +`api/GetAllSubModulesByModuleId?PartnerID=${encPartnerID}&ModuleId=${ModuleID}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {

                SubModuleSet(response.data);
               // SubModuleInfo.ModuleId = response.data[0].moduleId;

            })
            .catch(error => {
                console.log(error.response)
            });
    }

    async function showAddSubject(subID, SubName) {
        const handleAddModule = () => setAddModule(true);
        SubjectInfo.Name = SubName;
        SubjectInfo.SubjectId = subID;

    }

    async function showAddmodule(modID, SubName, modName) {
        const handleSubModule = () => setSubModule(true);
        ModuleInfo.ModuleId = modID;
        SubjectInfo.Name = SubName;
        ModuleInfo.Name = modName;

    }

    return (
        <>
            <ToastContainer/>
            <div className="yoc-container  yoc-container--fluid  yoc-grid__item p-0 ">
                <div className="alert alert-light d-flex align-items-center mb-3 px-4 ">
                    <h5
                        className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                        style={{ fontSize: "14px;" }}
                    >
                        Setting
                    </h5>
                    <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-dark"></span>
                    <span className="text-danger font-weight-500 f13">
                        Master Settings
                    </span>
                </div>
                <div className="yoc-subheader__main bg-white px-3 mb-3 py-3">
                    <a
                        type="text"
                        href="#"
                        className="btn btn-pill btn-upper font-weight-normal ad-btn text-uppercase btn-orange waves-effect waves-light"
                    >
                        Master Settings
                    </a>
                    <a
                        type="text"
                        href="#"
                        className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                    >
                        Admin/ Users
                    </a>
                    <a
                        type="text"
                        href="#"
                        className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                    >
                        Admin/Users Rights
                    </a>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3 col-xl-3 order-lg-1 order-xl-1">

                    <div className="yoc-portlet yoc-portlet--head--noborder yoc-portlet--height-fluid custom-side">
                        <div className="yoc-portlet__head yoc-portlet__head--noborder">
                            <div className="yoc-portlet__head-label">
                                <div className="dropdown dropdown-inline">
                                    <span className="yoc-badge yoc-badge--inline yoc-badge--pill yoc-badge--success yoc-badge--rounded cursor-pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MASTER ENTERIES</span>
                                    <div className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-md custom_dropdown" x-placement="bottom-end" style={{ position: "absolute", willChange: "transform", top: "0px", left: "0px", transform: "translate3d(24px, 26px, 0px)" }}>

                                        <ul className="yoc-nav p-3">
                                            <li className="yoc-nav__head d-block text-center headingList">
                                                Select Master Entry
                                                <i className="flaticon2-information" data-toggle="yoc-tooltip" data-placement="right" title="" data-original-title="Click to learn more..."></i>
                                            </li>
                                            <li className="yoc-nav__item  mt-2">
                                                {/*<a href="/master-question-type" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk custom-lnk">Question's Type</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-question-type" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk custom-lnk">Question's Type</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item  mt-2">
                                                {/*<a href="/master-settings" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk ">Exam List</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-settings" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk ">Exam List</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                {/*<a href="/master-levels" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk">Difficulty Level</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-levels" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk">Difficulty Level</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                {/*<a href="/master-question" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk">Question Source</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-question" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk">Question Source</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                {/*<a href="/master-language" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk">Language</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-language" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk">Language</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                {/*<a href="/master-author" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk">Authors</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-author" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk">Authors</span>
                                                </Link>
                                            </li>

                                            <li className="yoc-nav__item mt-2">
                                                {/*<a href="/master-concept" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk">Concept</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-concept" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk">Concept</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                {/*<a href="/master-university" className="yoc-nav__link">*/}
                                                {/*    <span className="yoc-nav__link-text custom-lnk">University</span>*/}
                                                {/*</a>*/}
                                                <Link to="/master-university" className="yoc-nav__link">
                                                    <span className="yoc-nav__link-text custom-lnk">University</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__separator"></li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                            <div className="yoc-portlet__head-toolbar">
                                <div className="dropdown dropdown-inline">
                                    <button type="button" className="btn btn-clean btn-sm btn-icon btn-icon-lg" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="flaticon-more-1"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style={{ position: "absolute", willChange: "transform", top: "0px", left: "0px", transform: "translate3d(24px, 26px, 0px)" }}>
                                        <ul className="yoc-nav">
                                            <li className="yoc-nav__item">
                                                <a className="yoc-nav__link">
                                                    <i className="yoc-nav__link-icon flaticon2-refresh"></i>
                                                    <span className="yoc-nav__link-text">Refresh</span>
                                                </a>
                                            </li>
                                            <li className="yoc-nav__item">
                                                <a className="yoc-nav__link" onClick={handleEditExam }>
                                                    <i className="yoc-nav__link-icon flaticon2-edit"></i>
                                                    <span className="yoc-nav__link-text">Edit</span>
                                                </a>
                                            </li>
                                            <li className="yoc-nav__item">
                                                <a className="yoc-nav__link">
                                                    <i className="yoc-nav__link-icon flaticon2-trash"></i>
                                                    <span className="yoc-nav__link-text">Delete</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {data.map((user, key) => (
                            <tr key={key}>

                                <td>
                                    <div className="yoc-user-card-v2">
                                        <div className="yoc-portlet__body yoc-portlet__body--fluid yoc-portlet__body--fit">
                                            <div className="yoc-widget4 yoc-widget4--sticky">
                                                <div className="yoc-widget4__items yoc-widget4__items--bottom px-3 yoc-margin-b-20">
                                                    <div className="yoc-widget4__item">
                                                        <i className="fa fa-chevron-right mr-3 text-dark" aria-hidden="true"></i>
                                                        <div className="yoc-widget4__img yoc-widget4__img--logo">
                                                            <i className="fa fa-graduation-cap text-dark fa-2x" aria-hidden="true"></i>
                                                        </div>
                                                        <div className="yoc-widget4__info">
                                                            <a onClick={() => { GetExamDetailsByExamID(user.examId); }}
                                                                className="yoc-widget4__title">

                                                                <span className="yoc-user-card-v2__name font-weight-500 f14 text-dark">
                                                                    {user.examName}
                                                                </span>

                                                            </a>
                                                            <span className="yoc-widget4__sub">
                                                                {user.description}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                            </tr>
                        )).reverse()}



                        <div class="yoc-widget4__item w-75 mx-auto mb-3">
                            <button type="button" onClick={handleExam} className="btn btn-block mx-sm-auto btn-primary rounded-0 border" >
                                Add New Exam <i className="fa fa-plus ml-lg-2 ml-md-2 ml-sm-1 ml-1 f14" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>


                </div>

                <div className="col-lg-9 col-xs-9 order-lg-2 order-xl-2" >
                    <div className="yoc-portlet yoc-faq-v1" style={MainDiv}>
                        <div className="yoc-portlet__body">
                            <div className=" text-center" style={{ padding: "17% 0", background: "#f4f4f4" }}>
                                <p className="lead">Click On <span className="badge badge-dark">MASTER ENTERIES</span></p>

                                <p className="lead">to select and modify or update entries</p>
                            </div>
                        </div> 
                    </div>

                    <div className="yoc-portlet yoc-faq-v1" style={SubDiv}>
                        <div className="alert alert-light px-2">
                            <div className="alert alert-light d-flex align-items-center p-0 mb-0">
                                <h4 className="yoc-subheader__title ml-lg-3 ml-md-3 ml-sm-3 ml-2 f18 mb-0">{ExamInfo.ExamName}</h4>
                                <span className="seperator ml-lg-3 ml-md-3 ml-sm-3 ml-2"></span>
                                <button className="btn rounded-0 btn-info btn-sm" onClick={handleSubject}><i className="fa fa-plus" aria-hidden="true">
                                </i> Add New Subject</button>
                            </div>
                        </div>

                        <div className="yoc-portlet yoc-portlet--height-fluid yoc-portlet--mobile custom-side">

                            <div className="yoc-portlet__body yoc-portlet__body--fit ">
                                <div className="yoc-datatable yoc-datatable--default yoc-datatable--brand yoc-datatable--scroll yoc-datatable--loaded table-responsive" id="yoc_datatable_latest_orders" >
                                    <table className="table ">
                                        <thead className="yoc-datatable__head">
                                            <tr className="yoc-datatable__row" style={{ left: "0px" }}>
                                                <th data-field="ShipName" data-autohide-disabled="false" className="yoc-datatable__cell "><span className="thHeader">Subjects</span></th>
                                                <th data-field="ShipDate" className="yoc-datatable__cell "><span className="thHeader">Question Bank Strength</span></th>

                                                <th data-field="Type" className="yoc-datatable__cell  "><span className="thHeader">Modules</span></th>
                                            </tr>
                                        </thead>
                                        <tbody className="yoc-datatable__body ps ps--active-y">

                                            {SubjectList.map((subject, subjectkey) => (
                                                <>
                                                    <tr key={subjectkey} data-row="0" className="yoc-datatable__row" style={{ left: "0px" }}>

                                                        <td data-field="ShipName" data-autohide-disabled="false" className="yoc-datatable__cell">
                                                            <span>
                                                                <div className="yoc-user-card-v2">
                                                                    <div className="yoc-user-card-v2__pic">
                                                                        <img alt="photo" src="assets/media/maths.png" />
                                                                    </div>
                                                                    <div className="yoc-user-card-v2__details" onClick={() => { GetAllModules(subject.subjectId); }}>
                                                                        <a className="yoc-user-card-v2__name text-info" data-toggle="collapse" href={"#modulediv" + subject.subjectId} title={subject.description}>{subject.name}</a>
                                                                        <span className="yoc-user-card-v2__email">Q. Used/ Unused <span className="text-danger">| NA/NA</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </td>

                                                        <td data-field="ShipDate" className="yoc-datatable__cell">
                                                            <div className="yoc-user-card-v2">
                                                                <div className="yoc-user-card-v2__details" >
                                                                    <span className="yoc-user-card-v2__email ln-14">Questions Added / Corrected <strong>
                                                                        <span className="text-dark">: NA / NA</span></strong> (This Month)</span>
                                                                </div>
                                                            </div>


                                                            <div className="yoc-user-card-v2">
                                                                <div className="yoc-user-card-v2__details">
                                                                    <span className="yoc-user-card-v2__email ln-14">
                                                                        Questions  Created <strong><span className="text-dark">: NA</span></strong> (NA Date)
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </td>

                                                        <td data-field="Actions" data-autohide-disabled="false" className="yoc-datatable__cell d-flex">
                                                            <span className="pr-sm-3">
                                                                <button type="button" className="btn btn-sm btn-label-success rounded-0" onClick={() => { showAddSubject(subject.subjectId, subject.name); handleAddModule(); }}>
                                                                    <i className="fa fa-plus" aria-hidden="true"></i> Add Module
                                                                </button>
                                                            </span>
                                                            <div className="dropdown ml-sm-4" style={{ overflow: "visible", position: "relative", width: "80px" }}>
                                                                <a data-toggle="dropdown" className="btn btn-sm btn-clean btn-icon btn-icon-md" aria-expanded="false">
                                                                    <i className="flaticon-more-1"></i>
                                                                </a>
                                                                <div className="dropdown-menu dropdown-menu-right ml-sm-4" x-placement="bottom-end" style={{ position: "absolute", willChange: "transform", top: "0px", left: "0px", transform: "translate3d(12px, 32px, 0px)" }}>
                                                                    <ul className="yoc-nav">
                                                                        <li className="yoc-nav__item">
                                                                            <a className="yoc-nav__link" onClick={() => { GetNewSubjectByID(subject.examid, subject.subjectId, subject.name); handleEditSubject(); }}>
                                                                                <i className="yoc-nav__link-icon la la-pencil"></i> <span className="yoc-nav__link-text">Edit</span>
                                                                            </a>
                                                                        </li>
                                                                        <li className="yoc-nav__item">
                                                                            <a className="yoc-nav__link" href="#">
                                                                                <i className="yoc-nav__link-icon flaticon2-trash"></i><span className="yoc-nav__link-text">Delete</span>
                                                                            </a>
                                                                        </li>
                                                                        <li className="yoc-nav__item">
                                                                            <a className="yoc-nav__link" href="#"> <i className="yoc-nav__link-icon flaticon2-refresh"></i> <span className="yoc-nav__link-text">Refresh</span> </a>
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>

                                                    {ModuleList.map((module, modulekey) => {
                                                        return module.subjectid === subject.subjectId ? (
                                                            <tr key={modulekey} data-row="0" className="yoc-datatable__row" style={{ left: "0px" }} id={"modulediv" + module.subjectid}>
                                                                <td colSpan="4">
                                                                    <div className="row mx-5 py-3 border border-left-0 border-right-0 border-top-0">
                                                                        <div className="col-md-6 d-flex align-items-center pl-md-4" data-toggle="collapse" href={"#subModuleTwo" + module.subjectid + "_" + module.moduleId}>
                                                                            <span className="f15 font-weight-500 cursor-pointer" onClick={() => { GetAllSubModules(module.moduleId); }}>
                                                                                <i className="fa fa-graduation-cap text-dark" aria-hidden="true" title={module.description}></i> {module.name}
                                                                            </span>
                                                                            <div className="dropdown ml-sm-4" style={{ overflow: "visible", position: "relative", width: "80px" }}>
                                                                                <a data-toggle="dropdown" className="btn btn-sm btn-clean btn-icon btn-icon-md" aria-expanded="false">
                                                                                    <i className="flaticon-more-1"></i>
                                                                                </a>
                                                                                <div className="dropdown-menu dropdown-menu-right ml-sm-4" x-placement="bottom-end" style={{ position: "absolute", willChange: "transform", top: "0px", left: "0px", transform: "translate3d(12px, 32px, 0px)" }}>
                                                                                    <ul className="yoc-nav">
                                                                                        <li className="yoc-nav__item">
                                                                                            <a className="yoc-nav__link" onClick={() => { GetModuleByID(subject.subjectId, module.moduleId, module.name); handleEditModule(); }} > <i className="yoc-nav__link-icon la la-pencil"></i> <span className="yoc-nav__link-text">Edit</span> </a>
                                                                                        </li>
                                                                                        <li className="yoc-nav__item">
                                                                                            <a className="yoc-nav__link" href="#">

                                                                                                <i className="yoc-nav__link-icon flaticon2-trash"></i><span className="yoc-nav__link-text">Delete</span>
                                                                                            </a>
                                                                                        </li>
                                                                                        <li className="yoc-nav__item">
                                                                                            <a className="yoc-nav__link" href="#"> <i className="yoc-nav__link-icon flaticon2-refresh"></i> <span className="yoc-nav__link-text">Refresh</span> </a>
                                                                                        </li>

                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 text-right">
                                                                            <button type="button" className="btn btn-sm rounded-0 btn-primary mr-md-5" onClick={() => { showAddmodule(module.moduleId, subject.name ,module.name); handleSubModule(); }} >
                                                                                <i className="fa fa-plus" aria-hidden="true"></i> Add Sub Module
                                                                            </button>
                                                                        </div>



                                                                        <div className="col-12 collapse" id={"subModuleTwo" + module.subjectid + "_" + module.moduleId}>
                                                                            {SubModuleList.map((submodule, submodulekey) => {
                                                                                return module.moduleId === submodule.moduleId ? (
                                                                                    <div key={submodulekey} className="row py-2">
                                                                                        <div className="col-sm-11 d-flex align-items-center mx-auto">

                                                                                            <span className="text-dark f14 font-weight-normal" title={submodule.description} >{submodule.name}</span>

                                                                                            <div className="dropdown ml-sm-4">
                                                                                                <a data-toggle="dropdown" className="btn btn-sm btn-clean btn-icon btn-icon-md">
                                                                                                    <i className="flaticon-more-1"></i>
                                                                                                </a>
                                                                                                <div className="dropdown-menu dropdown-menu-right ml-sm-4">
                                                                                                    <ul className="yoc-nav">
                                                                                                        <li className="yoc-nav__item">
                                                                                                            <a className="yoc-nav__link" onClick={() => { GetSubModuleByID(module.moduleId, submodule.subModuleId); handleEditSubModule(); }}> <i className="yoc-nav__link-icon la la-pencil"></i> <span className="yoc-nav__link-text">Edit</span> </a>
                                                                                                        </li>
                                                                                                        <li className="yoc-nav__item">
                                                                                                            <a className="yoc-nav__link" href="#">
                                                                                                                <i className="yoc-nav__link-icon flaticon2-trash"></i><span className="yoc-nav__link-text">Delete</span>
                                                                                                            </a>
                                                                                                        </li>

                                                                                                    </ul>
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className="text-md-right w-25">
                                                                                                <span className="">300/360</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : null;
                                                                            }).reverse()}
                                                                        </div>

                                                                    </div>

                                                                </td>
                                                            </tr>
                                                        ) : null;
                                                    }).reverse()}

                                                </>
                                            )).reverse()}

                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <Modal
                show={Exam}
                onHide={ExamClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Add New Exam</Modal.Title>
                        <Button onClick={ExamClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Exam Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    id="Name"
                                    name="Name"
                                    aria-describedby=""
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Module Name:</p>
                            </div>
                            <div className="col-md-9">
                                <p> <b>Exams</b></p>
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="Description"
                                    name="Description"
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={AddExams}>
                            Add 
                        </Button>
                        <Button variant="primary" onClick={ExamClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={EditExam}
                onHide={EditExamClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>Edit Exam</Modal.Title>
                        <Button onClick={EditExamClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Exam Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="ExamId"
                                    aria-describedby=""
                                    id="ExamId"
                                    name="ExamId"
                                    value={ExamInfo.ExamId}
                                />
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    defaultValue={ExamInfo.ExamName}
                                    id="Name"
                                    name="Name"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Module Name:</p>
                            </div>
                            <div className="col-md-9">
                                <p> <b>Exams</b></p>
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={ExamInfo.Description}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="Description"
                                    name="Description"
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={UpdateExams}>
                            Update
                        </Button>
                        <Button variant="primary" onClick={EditExamClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={Subject}
                onHide={subjectClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>Add New Subject</Modal.Title>
                        <Button onClick={subjectClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-2">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-10">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    id="Name"
                                    name="name"
                                    aria-describedby=""
                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            {/*<div className="col-md-2">*/}
                            {/*    <p>Exam:</p>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-10">*/}
                            {/*    <p> <b>{ExamInfo.ExamName}</b></p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    id="Description"
                                    name="Description"
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateForm}>
                            Add
                        </Button>
                        <Button variant="primary" onClick={subjectClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={EditSubject}
                onHide={EditsubjectClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>Edit  Subject</Modal.Title>
                        <Button onClick={EditsubjectClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-2">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-10">
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="ExamID"
                                    aria-describedby=""
                                    id="ExamID"
                                    name="ExamID"
                                    value={NewSubjectId.examid}
                                />
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="SubjectID"
                                    name="SubjectID"
                                    value={NewSubjectId.subjectId}
                                />
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="subName"
                                    name="name"
                                    defaultValue={NewSubjectId.name}
                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            {/*<div className="col-md-2">*/}
                            {/*    <p>Exam:</p>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-10">*/}
                            {/*    <p> <b>{ExamInfo.ExamName}</b></p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    // value={content}
                                    id="subDescription"
                                    name="Description"
                                    value={NewSubjectId.description}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}

                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateFormUpdate}>
                            Update
                        </Button>
                        <Button variant="primary" onClick={EditsubjectClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={AddModule}
                onHide={AddModuleClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>
                            <div>
                                <div>Add Module</div>
                                <div>
                                    <span className="beside-md-header">Exam Name : <span>{ExamInfo.ExamName}</span>
                                        <span className="mx-2 text-danger">&gt;</span> <br />Subject Name: <span>{SubjectInfo.Name}</span>
                                    </span>
                                </div>
                            </div>
                        </Modal.Title>

                        <Button onClick={AddModuleClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="ModuleName"
                                    name="name"
                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            {/*<div className="col-md-3">*/}
                            {/*    <p>Subject:</p>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-9">*/}
                            {/*    <p> <b>{SubjectInfo.Name}</b></p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">
                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="ModuleDescription"
                                    name="Description"
                                />
                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateFormAddModule}>
                            Add
                        </Button>
                        <Button variant="primary" onClick={AddModuleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={EditModule}
                onHide={EditModuleClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>
                            <div>
                                <div>Edit Module</div>
                                <div>
                                    <span className="beside-md-header">Exam Name : <span>{ExamInfo.ExamName}</span>
                                        <span className="mx-2 text-danger">&gt;</span> <br />Subject Name: <span>{SubjectInfo.Name}</span>

                                    </span>
                                </div>
                            </div>
                        </Modal.Title>

                        <Button onClick={EditModuleClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="SubjectID"
                                    aria-describedby=""
                                    id="SubjectID"
                                    name="SubjectID"
                                    value={NewModuleId.subjectid}
                                />
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="ModuleID"
                                    aria-describedby=""
                                    id="ModuleID"
                                    name="ModuleID"
                                    value={NewModuleId.moduleId}
                                />
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="ModuleName"
                                    name="name"
                                    defaultValue={NewModuleId.name}
                                />

                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            {/*<div className="col-md-3">*/}
                            {/*    <p>Subject:</p>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-9">*/}
                            {/*    <p> <b>{ModuleInfo.Name}</b></p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="ModuleDescription"
                                    name="Description"
                                    value={NewModuleId.description}
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateFormUpdateModule}>
                            Update
                        </Button>
                        <Button variant="primary" onClick={EditModuleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={SubModule}
                onHide={SubModuleClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>
                            <div>
                                <div>Add Sub Module </div>
                                <div>
                                    <span className="beside-md-header">Exam Name : <span>{ExamInfo.ExamName}</span>

                                        <span className="mx-2 text-danger"></span> <br />Subject Name: <span>{SubjectInfo.Name}</span>
                                        <span className="mx-2 text-danger"></span> <br />Module Name: <span>{ModuleInfo.Name}</span>
                                    </span>
                                </div>
                            </div>
                        </Modal.Title>

                        <Button onClick={SubModuleClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="SubModuleName"
                                    name="Name"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            {/*<div className="col-md-3">*/}
                            {/*    <p>Module Name:</p>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-9">*/}
                            {/*    <p> <b>{ModuleInfo.Name}</b></p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="SubModuleDescription"
                                    name="Description"
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={AddNewSubModule}>
                            Add
                        </Button>
                        <Button variant="primary" onClick={SubModuleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={EditSubModule}
                onHide={EditSubModuleClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right">
                    <Modal.Header>
                        <Modal.Title>
                            <div>
                                <div>Edit Sub Module </div>
                                <div>
                                    <span className="beside-md-header">Exam Name : <span>{ExamInfo.ExamName}</span>
                                        <span className="mx-2 text-danger"></span> <br />Subject Name: <span>{SubjectInfo.Name}</span>
                                        <span className="mx-2 text-danger"></span> <br />Module Name: <span>{ModuleInfo.Name}</span>
                                    </span>
                                </div>
                            </div>
                        </Modal.Title>

                        <Button onClick={EditSubModuleClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">

                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="ModuleID"
                                    aria-describedby=""
                                    id="ModuleID"
                                    name="ModuleID"
                                    value={NewsubModuleId.moduleId}
                                />

                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="SubModuleID"
                                    aria-describedby=""
                                    id="SubModuleID"
                                    name="SubModuleID"
                                    value={NewsubModuleId.subModuleId}
                                />

                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="SubModuleName"
                                    name="Name"
                                    defaultValue={NewsubModuleId.name}
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            {/*<div className="col-md-3">*/}
                            {/*    <p>Module Name:</p>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-9">*/}
                            {/*    <p> <b>{ModuleInfo.Name}</b></p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="SubModuleDescription"
                                    name="Description"
                                    value={NewsubModuleId.description}
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={UpdateSubModule}>
                           Update
                        </Button>
                        <Button variant="primary" onClick={EditSubModuleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>


        </>
    )
}

export default MasterSetting